import { useState, useEffect } from 'react';

export const useTraderStatistics = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchTraderStatistics = async () => {
    try {
      setLoading(true);
      setError(null);

      // Call the Firebase function to get processed leaderboard data
      const response = await fetch(
        'https://us-central1-fxwars.cloudfunctions.net/getLeaderboard',
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        setLeaderboardData(data.data || []);
        setLastUpdated(data.lastUpdated ? new Date(data.lastUpdated) : new Date());
      } else {
        throw new Error(data.message || 'Failed to fetch leaderboard data');
      }

    } catch (err) {
      console.error('Error fetching trader statistics:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTraderStatistics();
  }, []);

  const refetch = () => {
    fetchTraderStatistics();
  };

  return {
    loading,
    error,
    leaderboardData,
    lastUpdated,
    refetch,
  };
}; 